module.exports = require("react-markdown");


//////////////////
// WEBPACK FOOTER
// external "react-markdown"
// module id = 133
// module chunks = 0